export const SET_AUTH = 'SET_AUTH';
export const SET_CHARACTERS = 'SET_CHARACTERS';
export const SET_COMICS = 'SET_COMICS';
export const SET_CREATORS = 'SET_CREATORS';
export const SET_THEME = 'SET_THEME';
